const PERMISSION_KEY= "personalize:portfolio_wallet_margin_history";
const PAGE_URL = {
    PORTFOLIO_WALLET_MARGIN_HISTORY_PAGE: "/admin/personalize/portfolio-wallet-margin-history"
}

export {PERMISSION_KEY, PAGE_URL}

